<template>
  <div>
    <div class="air__utils__heading">
      <div class="d-flex justify-content-between">
        <h5>Aguardando Informações</h5>
      </div>
    </div>
    <div class="row">
      <lista-onboardings class="mb-4" />
    </div>
  </div>
</template>
<script>
import ListaOnboardings from "./lista";

export default {
  components: {
    ListaOnboardings
  },
  data: function() {
    return {};
  },
  methods: {},
  mounted() {}
};
</script>
